import { Serializable } from "../core";
import { User } from "./user";

export type DiscountType = "delivery" | "product";

export class Discount implements Serializable<Discount> {
  public id!: string;
  public type!: DiscountType;
  public amount!: number;
  public code!: string;
  public user?: User;
  public expiration!: Date;

  deserialize(json: any): Discount {
    this.id = json.id;
    this.type = json.usage.toLowerCase();
    this.amount = json.amount;
    this.code = json.code;
    if (json.user !== null) this.user = new User().deserialize(json.user);
    this.expiration = new Date(json.expiration);
    return this;
  }
}
